<template>
  <div class="container">
    <section>
      <div class="layout">
        <div class="child">
          <div class="pure-g">
            <div class="pure-u-1">
              <div>
                <h2>{{questionTitle}}</h2>
              </div>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1">
              <div>
                <h3>
                  Use this space to tell your study respondents what the study is about. We recommend 2-3 complete
                  sentences. Be general, not too specific.
                </h3>
              </div>
            </div>
          </div>
          <div>
            <form class="pure-form pure-form-stacked" @submit.prevent="handleSubmit" novalidate>
              <fieldset>
                <div class="pure-g">
                  <div class="pure-u-1">
                    <RichTextEditor v-model="formModel.orientationText" />
                  </div>
                </div>
                <div v-if="showOrientationValidationUI">
                  <div class="invalid">
                    <small>{{minimumCharacterWarning}}</small>
                  </div>
                </div>
                <button type="submit" class="hidden-submit"></button>
              </fieldset>
              <BigStudyNavigation @touched="onTouched"></BigStudyNavigation>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {
    GET_NEXT_STUDY_STEP_ROUTE,
    GET_IN_PROGRESS_STUDY_RESPONDENT_ORIENTATION,
    SET_IN_PROGRESS_STUDY_RESPONDENT_ORIENTATION,
    UPDATE_STUDY,
    CSS_CLASS_NAME_INVALID,
  } from '../../services/constants'
  import RichTextEditor from "@/components/general/RichTextEditor"

  const MIN_CHAR_LENGTH = 50

  export default {
    name: 'RespondentOrientation',
    components: {RichTextEditor},
    data() {
      return {
        formModel: null,
        submitTouched: false,
      }
    },
    computed: {
      ...mapGetters([
        GET_NEXT_STUDY_STEP_ROUTE,
        GET_IN_PROGRESS_STUDY_RESPONDENT_ORIENTATION,
      ]),
      questionTitle() {
        return 'RESPONDENT ORIENTATION'
      },
      isOrientationValid() {
        return this.formModel.orientationText.trim().length >= MIN_CHAR_LENGTH
      },
      showOrientationValidationUI() {
        return !this.isOrientationValid && this.submitTouched
      },
      orientationValidationClassObj() {
        return {
          [CSS_CLASS_NAME_INVALID]: this.showOrientationValidationUI,
        }
      },
      isFormModelValid() {
        return this.isOrientationValid
      },
      textareaRefName() {
        return 'textareaRef'
      },
      minimumCharacterWarning(){
        return `Don't pass up this chance to share your idea! Please write at least ${MIN_CHAR_LENGTH} characters`
      }
    },
    methods: {
      handleSubmit() {
        if (this.isFormModelValid) {
          this.$store.commit(SET_IN_PROGRESS_STUDY_RESPONDENT_ORIENTATION, this.formModel.orientationText)
          this.$store.dispatch(UPDATE_STUDY).then(() => {
            this.$router.push(this[GET_NEXT_STUDY_STEP_ROUTE])
          })
        }
      },
      resetFormModel() {
        this.formModel = Object.assign({}, {
          orientationText: this[GET_IN_PROGRESS_STUDY_RESPONDENT_ORIENTATION],
        })
      },
      onTouched() {
        this.submitTouched = true
      },
    },
    created() {
      this.resetFormModel()
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../scss/main";

  .container {
    height: 100%;
  }

  section {
    height: 100%;
  }

  .layout {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100%;
  }

  .child {
    width: 100%;
    max-width: 500px;
    margin: 1em;
  }

  h2 {
    text-align: center;
    color: $red-2;
  }

  h3 {
    color: $cyan-blue-3;
  }

  .pure-form textarea {
    box-shadow: none;
    width: 100%;
    color: $cyan-blue-3;
    border-color: $cyan-blue-3;

    &:focus {
      border-color: $cyan-blue-1;
    }
    &:placeholder-shown {
      color: $gray-3;
    }
    &:-ms-input-placeholder {
      color: $gray-3;
    }

    &.invalid {
      border-color: $red-2;
    }
  }

  .question-title {
    font-size: 0.83em;
    font-weight: bold;
    color: $cyan-blue-3;
  }

  .invalid {
    color: $red-2;
  }

</style>
